import { EVALUATION_TYPES } from "../../../../../components/dashboard/hse/evaluation/evaluationUtils";
import { EvaluationListPage } from "../../../../../components/dashboard/hse/evaluation/EvaluationListPage";

export const HseKsAuditsList = () => (
  <EvaluationListPage evaluationType={EVALUATION_TYPES.INTERNAL_AUDIT} />
);
